export function isDfcMutationResult(res) {
  return res !== null && typeof res === 'object' && 'data' in res && res.data !== null && typeof res.data === 'object' && 'result' in res.data;
}